// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculateFont.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DataType component
 */
import React from 'react';
import { observer } from 'mobx-react';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import FontStyle from 'share/components/controls/Izenda.FontStyle';
import FontFormat from 'share/components/controls/Izenda.FontFormat';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';

@observer
class Font extends React.Component {
  static displayName = 'Font';

  constructor(props) {
    super(props);

    let {
      store: { clonedModel: model },
      type: { name: typeName }
    } = this.props;
    let valueFontFormat;
    let valueFontStyle;

    if (typeName === constants.TYPES.SUB_TOTAL.name) {
      valueFontStyle = {
        bold: constants.DEFAULT_VALUE_PROPERTIES.SUB_TOTAL.FONT.BOLD,
        italic: constants.DEFAULT_VALUE_PROPERTIES.FONT.ITALIC,
        underline: constants.DEFAULT_VALUE_PROPERTIES.FONT.UNDERLINE
      };
      valueFontFormat = {
        size: constants.DEFAULT_VALUE_PROPERTIES.FONT.SIZE,
        family: constants.DEFAULT_VALUE_PROPERTIES.FONT.FAMILY
        // ...valueFontStyle
      };
    } else {
      valueFontStyle = {
        bold: constants.DEFAULT_VALUE_PROPERTIES.GRAND_TOTAL.FONT.BOLD,
        italic: constants.DEFAULT_VALUE_PROPERTIES.FONT.ITALIC,
        underline: constants.DEFAULT_VALUE_PROPERTIES.FONT.UNDERLINE
      };
      valueFontFormat = {
        size: constants.DEFAULT_VALUE_PROPERTIES.FONT.SIZE,
        family: constants.DEFAULT_VALUE_PROPERTIES.FONT.FAMILY
        // ...valueFontStyle
      };
    }

    // Change default values if already updated
    if(model.font && model.font.size) valueFontFormat.size = model.font.size;
    if(model.font && model.font.family) valueFontFormat.family = model.font.family;
    if(model.font && model.font.isChanged) valueFontStyle.bold = model.font.bold;
    if(model.font && model.font.italic) valueFontStyle.italic = model.font.italic;
    if(model.font && model.font.underline) valueFontStyle.underline = model.font.underline;

    this.state = {
      size: valueFontFormat.size,
      family: valueFontFormat.family,
      bold: valueFontStyle.bold,
      italic: valueFontStyle.italic,
      underline: valueFontStyle.underline,
      // textColor: constant.DEFAULT_VALUE.COLOR,
      // alignment: constant.DEFAULT_VALUE.ALIGNMENT
      valueFontFormat: valueFontFormat,
      valueFontStyle: valueFontStyle
    };

    
  }

  /**
   * Hanld change font format
   * @param  {object} e
   */
  onChangeFontFormat = (e) => {
    let value = e.value || {};
    this.setState({
      size: value.fontSize,
      family: value.fontFamily
    });

    this.props.store.clonedModel.changeFont({
      size: value.fontSize,
      family: value.fontFamily,
      bold: this.state.bold,
      italic: this.state.italic,
      underline: this.state.underline
    });
  }

  onChangeFontStyle = (e) => {
    let value = e.value || {};
    this.setState({
      bold: value.fontBold,
      italic: value.fontItalic,
      underline: value.fontUnderline
    });
    this.props.store.clonedModel.changeFont({
      size: this.state.size,
      family: this.state.family,
      bold: value.fontBold,
      italic: value.fontItalic,
      underline: value.fontUnderline
    });
  }

  render() {
    let {
      localization,
      type: { name: typeName }
    } = this.props;

    if (typeName !== constants.TYPES.SUB_TOTAL.name && typeName !== constants.TYPES.GRAND_TOTAL.name) {
      return null;
    }

    let state = this.state;
    let valueFontFormat = {
      fontSize: state.size,
      fontFamily: state.family
    };

    let fontStyle = {
      fontBold: state.bold,
      fontItalic: state.italic,
      fontUnderline: state.underline
    };

    return (
      <FormGroup className="u_paddingRight">
          <Label className="col-md-3 text-left u_paddingLeft">
            {localization.getText('FONT_SETTINGS_LABEL_FONT')}
        </Label>
        <div className="col-md-9 u_noPaddingAll grand-total-section">
            <FontFormat value={valueFontFormat} onChange={this.onChangeFontFormat} />
            <FontStyle value={fontStyle} onChange={this.onChangeFontStyle} />
        </div>
      </FormGroup>
    );
  }
}

export default Font;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.CalculateFont.js